<form [formGroup]="form" [patchForm]="selectedFilters$ | async">
  <h4 [hidden]="filterIsSelected$ | async">
    {{ 'general.selectAFilter' | translate }}
  </h4>
  <div class="row g-2 mb-4">
    <div class="col-12 col-md-6">
      <label class="form-label">
        {{ 'bookingModule.selectActivity' | translate }}
      </label>
      <product-select-input-multiple
        [products]="allowAsLinkedChildProducts$ | async"
        formControlName="selectedLinkedProductIds"
        [allowClearing]="true"
        (search)="onSearchProducts($event)"
        [dataTestId]="'booking-allowed-linked-products-multiple-select'"
      ></product-select-input-multiple>
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label">
        {{ 'locationModule.selectLocation' | translate }}
      </label>
      <product-select-input-multiple
        (search)="onSearchLocation($event)"
        [products]="locations$ | async"
        formControlName="selectedLocationIds"
        [allowClearing]="true"
        [dataTestId]="'booking-locations-multiple-select'"
      >
      </product-select-input-multiple>
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label" data-test-id="select-activity-create-booking">
        {{ 'bookingModule.selectResource' | translate }}
      </label>
      <product-select-input-multiple
        [products]="bookableProducts$ | async"
        formControlName="selectedBookableProductIds"
        [allowClearing]="true"
        (search)="onSearchProducts($event)"
        [dataTestId]="'booking-bookable-multiple-select'"
      >
      </product-select-input-multiple>
    </div>
    <div class="col-12 col-md-6">
      <label class="form-label">
        {{ 'bookingModule.selectResourceGroup' | translate }}
      </label>
      <product-select-input-multiple
        (search)="onSearchProducts($event)"
        [products]="productGroups$ | async"
        formControlName="selectedProductGroupIds"
        [allowClearing]="true"
        [dataTestId]="'booking-locations-multiple-select'"
      ></product-select-input-multiple>
    </div>
  </div>
</form>

<calendar
  (onClickEvent)="onClickEvent($event)"
  (onChangeDates)="onChangeDates($event)"
  [events]="calendarEvents$ | async"
  [selectedProducts]="totalProductsSelected"
>
</calendar>

<div class="mt-2">
  <i role="img" class="fa fa-check me-1 ms-3 small" aria-hidden="true"></i
  >{{ 'participationModule.isConfirmed' | translate }}
  <i role="img" class="fa fa-question me-1 ms-3 small" aria-hidden="true"></i>
  {{ 'participationModule.isUnconfirmed' | translate }}
  <i role="img" class="fa fa-users me-1 ms-3 small" aria-hidden="true"></i
  >{{ 'general.full' | translate }}
  <i role="img" class="fa fa-clock me-1 ms-3 small" aria-hidden="true"></i
  >{{ 'general.empty' | translate }}
  <span class="">
    <span class="legend-square bg-light dependant-product-style ms-3"></span>
    {{ 'productModule.dependantProducts' | translate }}
  </span>
  <span class="legend-square hours-disabled ms-3"></span>
  {{ 'bookingModule.disabledByYearCalendar' | translate }}
</div>
